// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1531":"f79158ba","2030":"f79158ba","2065":"46a2049d","9856":"6dfca57b"}[chunkId] + ".css";
};